// This file is auto-generated by the installer.
import XetuxProductsDefaultValue, { XetuxProductsAnswer } from 'plugins/xetux-products/Answer';
import ToastProductsDefaultValue, { ToastProductsAnswer } from 'plugins/toast-products/Answer';


export type AnswerList = {
    [key: string]: any;
    readonly "xetux-products" : XetuxProductsAnswer;
readonly "toast-products" : ToastProductsAnswer;
};

export const answers: AnswerList = {
    "xetux-products" : XetuxProductsDefaultValue,
"toast-products" : ToastProductsDefaultValue
}

